export const NOTIFY_ME_ACTION = "back in stock - notify me";
export const UPDATE_ITEM_ACTION = "update saved item";
export const DELETE_ITEM_ACTION = "delete saved item";
export const MOVE_ITEM_TO_BAG_ACTION = "add to bag";
export const ADD_ITEM_TO_BAG_ACTION = "saved items|wishlist|add to bag";
export const SORT_ITEMS_ACTION = "sort by applied";
export const BOARD_NO_LONGER_AVAILABLE = "board no longer available";
export const SHOW_FULFILMENT_INFO = "show fulfilment details";
export const GOOGLE_ADVERT_LOADED = "google advert loaded";
